module.exports = __webpack_public_path__ + "img/banner.058b1946.png";